export default __webpack_public_path__ + "static/media/empty-cashback-img.3665cfd5.svg";